import styled from 'styled-components';

export const SearchBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  min-height: 130px;
  padding: 20px 20px 10px;
  margin: ${({ noMargin }) => (noMargin ? '0' : '0 0 20px')};
  position: relative;
  border-radius: 20px;
  border: 1px solid rgba(157, 157, 157, 0.5);
  background: transparent;

  .main-search {
    width: 100%;
    padding: 0 0 10px;
    margin: 0 0 10px;
    font-size: 16px;
    line-height: 20px;
    height: auto;
    border-radius: 0;
    border: none;
    box-shadow: none;
    outline: none;
    background: none;

    &::placeholder {
      color: rgba(0, 0, 0, 0.5);
    }
  }
`;

export const SearchItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  line-height: 20px;
  color: var(--text-color);

  .item-box.open-up .auto-dropdown,
  .item-box.open-up .web-dropdown {
    bottom: 100%;
    top: auto;
    margin-bottom: 8px;
  }

  .item-box.open-down .auto-dropdown,
  .item-box.open-down .web-dropdown {
    top: 100%;
    bottom: auto;
    margin-top: 8px;
  }

  .wrap {
    display: flex;
    align-items: center;
    flex-grow: 1;
    gap: 3px;
  }

  .item-box {
    @media screen and (min-width: 768px) {
      position: relative;
    }

    &.active {
      .auto-dropdown,
      .web-dropdown {
        display: block;
      }
    }

    .btn {
      display: flex;
      align-items: center;
      gap: 3px;
      padding: 5px 7px;
      border-radius: 5px;
      font-size: 16px;
      line-height: 20px;

      &:hover {
        background: #ddd;
      }
    }
  }

  /* auto dropdown */
  .auto-dropdown,
  .web-dropdown {
    display: none;
    text-align: left;
    width: 343px;
    min-height: 250px;
    position: absolute;
    top: 100%;
    left: 0;
    padding: 10px 15px 15px;
    border-radius: 20px;
    border: 3px solid rgba(157, 157, 157, 0.4);
    box-shadow: 0 0 10px rgba(157, 157, 157, 0.6);
    background: var(--white);
    z-index: 99;

    @media screen and (min-width: 768px) {
      width: 390px;
      left: 0;
    }

    .list {
      list-style: none;
      font-size: 14px;
      line-height: 18px;
      margin: 0 0 10px;

      li {
        padding: 12px 0;
        cursor: pointer;
        border-bottom: 1px solid #9d9d9d;

        @media screen and (min-width: 768px) {
          padding: 12px 10px;
        }

        &:hover {
          background: rgba(254, 221, 88, 0.1);
        }
      }

      .head {
        display: flex;
        align-items: center;
        gap: 5px;
        margin: 0 0 10px;

        .title {
          display: block;
          font-size: 18px;
          line-height: 22px;
          font-weight: 500;
          text-transform: capitalize;
        }
        .tag {
          display: inline-block;
          font-size: 12px;
          line-height: 15px;
          padding: 3px 10px;
          border-radius: 7px;
          border: 1px solid #9d9d9d;
        }
      }
    }
    .agent-list-wrapper {
      max-height: 200px;
      overflow-y: auto;
      padding-right: 4px;
    }
    .custom-agent {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 5px;
      margin: 0 0 3px;
      border-radius: 5px;
      cursor: pointer;

      &.active {
        background: rgba(254, 221, 88, 0.4);
      }

      .icon-box {
        width: 28px;
        height: 28px;
        padding: 5px;
        border-radius: 5px;
        background: rgba(26, 42, 108, 0.1);

        img {
          display: block;
          max-width: 100%;
          height: auto;
        }
      }

      .title {
        display: block;
        font-size: 18px;
        line-height: 22px;
        font-weight: 500;
        text-transform: capitalize;
      }
    }

    .recent-search {
      width: 100%;
      position: relative;

      .subtitle {
        display: block;
        font-size: 16px;
        line-height: 20px;
        margin: 0 0 10px;
      }

      .recent-search-box {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 12px;
        cursor: pointer;

        .icon-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 6px;
          background: rgba(26, 42, 108, 0.2);
        }

        .title {
          display: block;
          font-size: 18px;
          line-height: 22px;
          font-weight: 600;
        }

        .arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0;
          font-size: 20px;
          line-height: 1;
        }
      }
    }

    .advance-btn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      margin-top: 25px;

      .title {
        display: block;
        font-size: 14px;
        line-height: 18px;
      }

      .arrow {
        font-size: 16px;
        line-height: 1;
      }
    }
    .btn-check {
      position: absolute;
      top: 16px;
      right: 10px;
      width: 45px;
      height: 26px;
      cursor: pointer;
      border-radius: 50px;
      background: #ccc;

      &.checked {
        background: black;

        &::before {
          left: 21px;
        }
      }

      &::before {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: 22px;
        height: 22px;
        transition: all ease-in-out 0.3s;
        border-radius: 50px;
        background: white;
      }
    }

    /* .checkbox-label {
      width: 37px;
      height: 22px;
      position: absolute;
      top: 10px;
      right: 10px;
      display: flex;
      align-items: center;
      cursor: pointer;
      user-select: none;
      border-radius: 50px;
      background: red;

      input[type='checkbox'] {
        display: none;

        &:checked ~ .custom-checkbox {
          left: 17px;
        }

        &:checked {
          background: #D6FF3D;
        }
      }

      .custom-checkbox {
        position: absolute;
        top: 2px;
        left: 2px;
        height: 18px;
        width: 18px;
        background: var(--white);
        border-radius: 50%;
        transition: all ease-in-out 0.3s;
      }
    } */
  }

  /* web dropdown */
  .web-dropdown {
    min-height: auto;
  }

  .mic-btn-wrap {
    display: flex;
    align-items: center;
    gap: 4px;

    .mic-btn,
    .enter-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 32px;
      padding: 5px 7px;
      border-radius: 10px;

      &:hover {
        background: #ddd;
      }
    }
  }
`;
